interface SegmentedBarProps {
  value: number // 0-1000
  segments?: number
  color?: string
}

export function SegmentedBar({ value, segments = 12, color = '#4a90d9' }: SegmentedBarProps) {
  const filled = Math.round((value / 1000) * segments)
  return (
    <div className="flex items-center gap-[3px] flex-1">
      {Array.from({ length: segments }, (_, i) => (
        <span
          key={i}
          className="h-[7px] flex-1 rounded-full transition-all duration-500"
          style={{
            background: i < filled ? color : 'rgba(120,150,180,0.18)',
            boxShadow: i < filled ? `0 0 6px ${color}55` : undefined,
          }}
        />
      ))}
    </div>
  )
}
